import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, mergeMap } from 'rxjs/operators';
import { SupplierService } from '@/core/services/supplier.service';
import {
    loadProviders, loadProvidersSuccess, loadProvidersFailure,
    addProvider, addProviderSuccess, addProviderFailure,
    updateProvider, updateProviderSuccess, updateProviderFailure,
    deleteProvider, deleteProviderSuccess, deleteProviderFailure,
} from './provider.actions';

@Injectable()
export class ProviderEffects {
    private readonly actions$ = inject(Actions);
    private readonly service = inject(SupplierService);

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadProviders),
            switchMap(() =>
                this.service.getAll().pipe(
                    map(items => loadProvidersSuccess({ items })),
                    catchError(error => of(loadProvidersFailure({ error })))
                )
            )
        )
    );

    add$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addProvider),
            mergeMap(({ item }) =>
                this.service.add(item).pipe(
                    map(created => addProviderSuccess({ item: created })),
                    catchError(error => of(addProviderFailure({ error })))
                )
            )
        )
    );

    update$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateProvider),
            mergeMap(({ item }) =>
                this.service.update(item).pipe(
                    map(updated => updateProviderSuccess({ item: updated })),
                    catchError(error => of(updateProviderFailure({ error })))
                )
            )
        )
    );

    delete$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteProvider),
            mergeMap(({ id }) =>
                this.service.delete(id).pipe(
                    map(() => deleteProviderSuccess({ id })),
                    catchError(error => of(deleteProviderFailure({ error })))
                )
            )
        )
    );
}
